import React from 'react'
import { useNavigate } from 'react-router-dom';
import style from "./index.module.css"
import {
    CButton,
  } from "@coreui/react";
import CIcon from "@coreui/icons-react";

import {
    cilArrowThickLeft,
} from "@coreui/icons";


function PreviusButton() {

    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1); 
      };

    return (
        <div className={style.goBackBtn} onClick={handleGoBack}>      
           <CButton>
           <CIcon icon={cilArrowThickLeft} /> 
          </CButton>    
        </div>
    )
}

export default PreviusButton
